import React, { useEffect, useState } from 'react';
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import { STEP_VALUES } from './constants';
import { useIntl } from 'react-intl';
import {
  Wrapper, RangeWrapper, CustomRail, Segment,
  SliderContainer, Thumb, Label, Title
} from './styled';

const SeverityRange = ({ defaultMin, defaultMax, onChange, isDisabled, width }) => {
  const [values, setValues] = useState([defaultMin, defaultMax]);
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'severityRange' });

  useEffect(() => {
    setValues([defaultMin, defaultMax]);
  }, [defaultMin, defaultMax]);

  return (
    <Wrapper>
      <Title>{ title }</Title>
      <RangeWrapper isDisabled={ isDisabled } width={ width }>
        <CustomRail>
          {STEP_VALUES.map((step, idx) => (
            <Segment
              key={ step.value }
              color={ step.color }
              width={ `${100 / STEP_VALUES.length}%` }
              isOutsideRange={ idx < values[0] || idx > values[1] }
            />
          ))}
        </CustomRail>
        <SliderContainer>
          <Slider
            range
            min={ 0 }
            max={ 5 }
            step={ 1 }
            value={ values }
            onChange={ vals => {
              const sorted = [Math.min(vals[0], vals[1]), Math.max(vals[0], vals[1])];
              setValues(sorted);
            } }
            onChangeComplete={ vals => {
              const sorted = [Math.min(vals[0], vals[1]), Math.max(vals[0], vals[1])];
              onChange(sorted);
            } }
            handleRender={ (originHandle, props) => {
              const { value, dragging } = props;
              // Determine which value is left and which is right
              const leftValue = Math.min(values[0], values[1]);
              const rightValue = Math.max(values[0], values[1]);
              const isLeftThumb = value === leftValue;
              const isRightThumb = value === rightValue;
              const severity = STEP_VALUES[value];
              const isOverlap = leftValue === rightValue && value === leftValue;
              // Calculate segment positions
              const segmentWidth = 100 / STEP_VALUES.length;
              const segmentStart = value * segmentWidth;
              const segmentCenter = segmentStart + segmentWidth / 2;
              const segmentEnd = segmentStart + segmentWidth;

              let leftPos;
              let translateX;
              if (isOverlap) {
                leftPos = `${segmentCenter}%`;
                translateX = '-50%';
              } else if (isLeftThumb) {
                leftPos = `${segmentStart}%`;
                translateX = '0%';
              } else if (isRightThumb) {
                leftPos = `${segmentEnd}%`;
                translateX = '-100%';
              }

              let icon = null;
              if (isOverlap) {
                icon = (
                  <svg width="20" height="20" viewBox="0 0 20 20" style={ { display: 'block' } }>
                    <circle cx="10" cy="10" r="5" fill="#fff" />
                  </svg>
                );
              } else {
                icon = (
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    style={ {
                      display: 'block',
                      transform: isRightThumb ? 'scaleX(-1)' : undefined
                    } }
                  >
                    <polygon points="7,6 13,10 7,14" fill="#fff" />
                  </svg>
                );
              }
              return (
                <Thumb
                  { ...props }
                  className={ `severity-slider-thumb${dragging ? ' dragged' : ''}` }
                  leftPos={ leftPos }
                  translateX={ translateX }
                  style={ { ...props.style } }
                  isDisabled={ isDisabled }
                  title="Drag this handle (left/right) to set the range"
                >
                  {icon}
                  <Label className="severity-slider-thumb-label" firstLabel={ severity?.value === 0 && !isOverlap } lastLabel={ severity?.value === 5 && !isOverlap }>
                    {severity?.label}
                  </Label>
                </Thumb>
              );
            } }
            railStyle={ { background: 'transparent', height: 5 } }
            trackStyle={ [{ background: 'transparent' }] }
            allowCross={ false }
            disabled={ isDisabled }
          />
        </SliderContainer>
      </RangeWrapper>
    </Wrapper>
  );
};

export default SeverityRange;
